import React from 'react';
import { useTranslation } from '../i18n/useTranslation';

/**
 * Shared signup headline, body panel, mobile headline, and footer tagline
 * for auth surfaces (AuthView, SignupModal).
 */
export default function CommunityAuthMessaging({
  prefix = 'auth',
  showPanel = true,
  showMobileHeadline = true,
  showFooter = true,
}) {
  const { t } = useTranslation();
  const paragraphs = t('auth.community.body').split('\n\n');

  return (
    <>
      {showPanel && (
        <aside className={`${prefix}-community-panel`}>
          <h2 className={`${prefix}-community-headline`}>{t('auth.community.headline')}</h2>
          <div className={`${prefix}-community-body`}>
            {paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{paragraph}</p>
            ))}
          </div>
        </aside>
      )}

      {showMobileHeadline && (
        <h2 className={`${prefix}-community-headline-mobile`}>{t('auth.community.headline')}</h2>
      )}

      {showFooter && (
        <p className={`${prefix}-footer-tagline`}>{t('auth.footer.tagline')}</p>
      )}

      <style>{`
        .${prefix}-community-panel {
          display: none;
        }
        .${prefix}-community-headline-mobile {
          display: block;
          font-size: 22px;
          font-weight: 700;
          color: #111;
          letter-spacing: -0.4px;
          line-height: 1.3;
          text-align: center;
          margin: 0 0 4px;
          padding: 0 8px;
          max-width: 420px;
        }
        .${prefix}-footer-tagline {
          margin: 20px 0 0;
          padding: 0 12px;
          max-width: 420px;
          text-align: center;
          font-size: 13px;
          line-height: 1.5;
          color: #888;
          font-style: italic;
        }
        @media (min-width: 768px) {
          .${prefix}-community-panel {
            display: block;
            flex: 0 0 45%;
            padding: 24px 8px 24px 0;
          }
          .${prefix}-community-headline-mobile {
            display: none;
          }
          .${prefix}-footer-tagline {
            text-align: right;
            padding-right: 0;
          }
        }
        .${prefix}-community-headline {
          font-size: 28px;
          font-weight: 700;
          color: #111;
          letter-spacing: -0.5px;
          line-height: 1.25;
          margin: 0 0 20px;
        }
        .${prefix}-community-body p {
          font-size: 15px;
          line-height: 1.65;
          color: #555;
          margin: 0 0 16px;
        }
        .${prefix}-community-body p:last-child {
          margin-bottom: 0;
          font-weight: 600;
          color: #333;
        }
      `}</style>
    </>
  );
}

export function communityLayoutStyles(prefix = 'auth') {
  return `
    .${prefix}-layout {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      max-width: 980px;
      gap: 20px;
    }
    .${prefix}-form-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
    @media (min-width: 768px) {
      .${prefix}-layout {
        flex-direction: row;
        align-items: flex-start;
        gap: 48px;
      }
      .${prefix}-form-column {
        flex: 0 0 55%;
        align-items: flex-end;
      }
    }
  `;
}
